import { render } from "./servidor-basic-info.vue?vue&type=template&id=5754e1e3"
import script from "./servidor-basic-info.vue?vue&type=script&lang=js"
export * from "./servidor-basic-info.vue?vue&type=script&lang=js"

import "./servidor-basic-info.vue?vue&type=style&index=0&id=5754e1e3&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__